// deno-lint-ignore-file ban-types
// deno-fmt-ignore-file
import { IsCyclic } from '../../types/cyclic.mjs';
import { IsIntersect } from '../../types/intersect.mjs';
import { Object, IsObject } from '../../types/object.mjs';
import { IsUnion } from '../../types/union.mjs';
import { FromCyclic } from './from-cyclic.mjs';
import { FromIntersect } from './from-intersect.mjs';
import { FromUnion } from './from-union.mjs';
import { FromObject } from './from-object.mjs';
export function FromType(type) {
    return (IsCyclic(type) ? FromCyclic(type.$defs, type.$ref) :
        IsIntersect(type) ? FromIntersect(type.allOf) :
            IsUnion(type) ? FromUnion(type.anyOf) :
                IsObject(type) ? FromObject(type.properties) :
                    Object({}));
}
